import { environment } from "../environments/environment";

const development = !environment.production
export const FUNCTIONS_URL = development
  ? 'http://localhost:5001/pager-online/us-central1'
  : 'https://us-central1-pager-online.cloudfunctions.net'


export const firebaseConfig = {
  apiKey: "AIzaSyD9z7d78mwmJv3BAzQpgv0VMWOEhVH-Fx0",
  authDomain: "pager-online.firebaseapp.com",
  projectId: "pager-online",
  storageBucket: "pager-online.appspot.com",
  messagingSenderId: "895987269737",
  appId: "1:895987269737:web:df3896fe4edc536df822f8"
};